import { render } from "./task-preview.vue?vue&type=template&id=8225c8a2"
import script from "./task-preview.vue?vue&type=script&lang=js"
export * from "./task-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__